import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import '../entrypoints/application.css'

const pages = import.meta.glob('../pages/**/*.tsx')

createInertiaApp({
  resolve: async (name: string) => {
    const page = pages[`../pages/${name}.tsx`]
    if (!page) {
      throw new Error(`Page not found: ${name}`)
    }
    return (await page()) as any
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
})
